import * as React from "react";
import { Icon, Image } from "semantic-ui-react";

import { StickerCardStyle, DeleteButton } from "./styled";

interface OwnProps {
  uri: string;
  onDelete: () => void;
}

const StickerCardFC: React.FC<OwnProps> = ({ uri, onDelete }: OwnProps) => {
  const [thumbnail, setThumbnail] = React.useState<string | undefined>();

  React.useEffect(() => {
    if (uri) {
      setThumbnail(uri);
    }
  }, [uri]);

  return (
    <StickerCardStyle className={"StickerCard"}>
      <Image src={thumbnail} />
      <DeleteButton onClick={onDelete}>
        <DeleteButton.Content visible>
          <Icon name="close" />
        </DeleteButton.Content>
      </DeleteButton>
    </StickerCardStyle>
  );
};

export const StickerCard = StickerCardFC;
